<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="infoTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isPublish" slot-scope="data">
          <span class="publish-status" v-if="data.row.isPublish*1 === 1">已发布</span>
          <span v-else>未发布</span>
        </template>
        <template slot="coverPath" slot-scope="data">
          <img class="table-img" :src="imgUrl + data.row.coverPath">
        </template>
        <template slot="wtFormTableListButtonsBefore" slot-scope="data">
          <wt-auth v-if="data.row.isPublish*1 === 1" :hasAnyPremission="form.formCode + ':PUBLISH'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toClickAction(data.row)">取消发布</el-button>
          </wt-auth>
          <wt-auth v-if="data.row.isPublish*1 !== 1" :hasAnyPremission="form.formCode + ':PUBLISH'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toClickAction(data.row)">发布</el-button>
          </wt-auth>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_EPROTECTION',
        formComponent: {
          view: { type: 'component', componentName: 'InfoEprotectionView', value: 'queryInformationDetailData', noRequest: true },
          add: { type: 'component', componentName: 'InfoEprotectionEdit', value: 'resetInformationDetailData' },
          edit: { type: 'component', componentName: 'InfoEprotectionEdit', value: 'queryInformationDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/information/informationList' },
          delete: { type: 'default', value: '/modules/information/informationDelete' }
        },
        formInputsData: [
          { name: '搜索资讯', key: 'title', value: '', type: 'text' },
          { name: '发布状态',
            key: 'updateTimeRange',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '未发布', value: '0' },
              { label: '已发布', value: '1' }
            ] },
          { name: '发布时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '图片', key: 'coverPath', type: 'custom' },
          { name: '资讯标题', key: 'title', type: 'text' },
          { name: '发布时间', key: 'updateTime', type: 'text', sortable: 'custom' },
          { name: '资讯标签', key: 'typeName', type: 'text' },
          { name: '创建人', key: 'createUserName', type: 'text' },
          { name: '发布状态', key: 'isPublish', type: 'custom' },
          { name: '阅读人数', key: 'previewCount', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonMinWidth: 280, buttonWidth: 280 }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          this.$store.dispatch('setInformationDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    toClickAction(row) {
      console.log(row)
      this.$wtUtil.deleteConfirm(this, row.isPublish === 1 ? '确认取消发布？' : '确认发布？').then(() => {
        request({
          url: '/modules/information/informationUpdateIsPublish',
          method: 'post',
          data: {
            informationId: row.id,
            isPublish: row.isPublish === 1 ? 0 : 1
          }
        }).then(res => {
          if (res.code === '0') {
            this.$message({ message: '操作成功', type: 'success' })
            this.$refs.infoTableRef.requestList()
          }
        })
      })
    }
  }
}
</script>
